import { NgModule } from '@angular/core';
import { DatastoreAppInstallTrackingModule } from '@freelancer/datastore/collections';
import { LoginSignupService } from './login-signup.service';

@NgModule({
  imports: [DatastoreAppInstallTrackingModule],
  providers: [LoginSignupService],
})
export class LoginSignupModule {}
